import React from 'react'

// PaymentStatusBadge (FE2) — the subscription-status pill, tones on the locked design-system
// semantic colours (teal=trial, emerald=active, amber=past_due, rose=lapsed/canceled, slate=
// internal/none). Display only — the backend owns `subscriptionStatus`.

const STATUS_META: Record<string, { label: string; tone: string; dot: string }> = {
  active: { label: 'Active', tone: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  trialing: { label: 'Trialing', tone: 'bg-teal-100 text-teal-700', dot: 'bg-teal-500' },
  // 'internal' is staff vocabulary — operators see the same "complimentary" wording as the
  // Business settings Overview plan card.
  internal: { label: 'Complimentary', tone: 'bg-slate-100 text-slate-700', dot: 'bg-slate-400' },
  past_due: { label: 'Payment due', tone: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  canceled: { label: 'Canceled', tone: 'bg-rose-100 text-rose-700', dot: 'bg-rose-500' },
  none: { label: 'Not subscribed', tone: 'bg-slate-100 text-slate-600', dot: 'bg-slate-300' },
}

export function statusMeta(status: string) {
  return STATUS_META[status] ?? STATUS_META.none
}

export default function PaymentStatusBadge({ status }: { status: string }) {
  const meta = statusMeta(status)
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`inline-flex h-2 w-2 rounded-full ${meta.dot}`} />
      <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.tone}`}>{meta.label}</span>
    </span>
  )
}
